import CommonModule, { QuestelServicesClient, HttpMethodEnum } from '@questelservices/common';
import store from '@/store';
import PageList from '@/models/Pagination/PageList';
import { OrderCase } from '@/models/Orders/OrderCase';
import { LoadData } from '@/models/Pagination/LoadData';
import { getModule } from 'vuex-module-decorators';

export class OrderCasesService {
  private client: QuestelServicesClient;
  private commonState = getModule(CommonModule, store);

  constructor() {
    this.client = new QuestelServicesClient(store, "/api");
  }

  public async getOrderCases(dataQuery: LoadData, orderId: Guid): Promise<PageList<OrderCase>> {
    const queryString = Object.keys(dataQuery).filter(prop => dataQuery[prop])
                      .map(key => {
                        return `${key}=${encodeURIComponent(dataQuery[key])}`
                      })
                      .join('&');
    const response = await this.client.get<PageList<OrderCase>>(`/v1/OrderCases/${orderId}?${queryString}`)
      console.log(response.Data);
    return {
      Data: response.Data,
      PageNumber: response.PageNumber,
      PageSize: response.PageSize,  
      TotalItemCount: response.TotalItemCount
    }
  }

  public async updateFile(orderId: Guid, data: FormData) {
    return await this.client.upload<number>(`/api/v1/OrderCases/${orderId}/upload`, data, "");
  }

  public async downloadTemplate(): Promise<any> {
    var request = new Request(`/api/v1/OrderCases/template`, {
      method: HttpMethodEnum.Get,
      headers: {
        "Authorization": `Bearer ${this.commonState.authToken}`,
      }
    });
    return fetch(request);
    }

    public async getReport(OrderID: Guid) {
        var id = OrderID;
        const form = new FormData();
        form.append('OrderID', OrderID);
        var request = new Request(`/api/v1/orders/ExcelReport`, {
            method: HttpMethodEnum.Post,
            body: form,
            headers: {
              "Authorization": `Bearer ${this.commonState.authToken}`,
            }
        });

        return fetch(request);
    }

    public async getCaseContract(caseId: Guid): Promise<any> {
        var request = new Request(`/api/v1/OrderCases/DownloadContract/${caseId}`, {
            method: HttpMethodEnum.Get,
        });

        return fetch(request);
    }
}